import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const PrivateLayout = ({ isSidebarOpen, toggleSidebar }) => {
    return (
        <div className="d-flex" style={{ minHeight: '100vh' }}>
            {/* Sidebar */}
            <Sidebar />

            <div className="main-content" style={{ flex: 1 }}>
                {/* Navbar */}
                <Navbar />

                {/* Main content */}
                <div className="container-fluid mt-5 pt-4">
                    <Outlet /> {/* Hier worden de specifieke pagina's van private routes getoond */}
                </div>
            </div>
        </div>
    );
};

export default PrivateLayout;
